<template>
  <div>
    <div class="vd-gl-search-form">
      <a-form layout="inline">
        <a-form-item>
          <a-input class="vd-input-xs" placeholder="文件类型" allowClear />
          <!-- 下拉 //todo -->
          <!-- 把类型参数传到接口中 -->
        </a-form-item>

        <a-form-item>
          <a-input class="vd-input-xs" placeholder="上传时间" allowClear />
          <!-- 时间选择器 有选择器组件 // todo 别的页面有时间选择器插件 根据我的用法 和引用的包 自己去弄一个 -->
          <!-- 把时间参数传到接口中 -->
        </a-form-item>
        <a-form-item>
          <a-button type="search" class="common-button">
            搜索
          </a-button>
          <a-button type="search">重置条件</a-button>
        </a-form-item>
      </a-form>
    </div>
    <div class="vd-gl-content">
      <!-- 内容 -->
      <a-row type="flex" class="vd-table-head">
        <a-col flex="auto" class="vd-table-name"> 上传文件列表</a-col>
        <a-col class="vd-table-tool">
          <a-button type="danger"> 批量删除 </a-button>
          <a-divider type="vertical" />
          <a-icon class="common-icon" type="reload"></a-icon>
        </a-col>
      </a-row>
      <div>
        <a-table
          row-key="id"
          :pagination="pagination"
          :data-source="list"
          size="small"
          :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
        >
          <a-table-column title="id" data-index="id" />
          <a-table-column align="center" title="文件名" data-index="filename" />
          <a-table-column title="类型" data-index="extension">
            <template slot-scope="item">
              {{ extension[item] }}
            </template>
          </a-table-column>
          <a-table-column title="文件路径" data-index="web_url" />
          <a-table-column align="center" title="来源" data-index="remark" />
          <a-table-column align="center" title="文件添加时间">
            <template slot-scope="id, record">
              {{ $FormatUtil.timestamp2date(record.add_time) }}
            </template>
          </a-table-column>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import { remove_item, get_list } from '@/api/ftp'
export default {
  name: 'ftp',
  data() {
    return {
      selectedRowKeys: [],
      loading: false,
      list: [],
      extension: {
        gif: '图片',
        png: '图片',
        jpg: '图片',
        pdf: 'PDF',
      },
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        onChange: (page) => {
          this.pagination.current = page
          this.getData()
        },
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      get_list({
        pageSize: this.pagination.pageSize,
        current: this.pagination.current,
        type: '参数1',
        dateRange: '参数2',
      }).then((res) => {
        if (res.code === 1) {
          this.list = res.list
          this.pagination.total = res.total
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    remove(id) {
      remove_item({ id }).then((res) => {
        console.log(res)
      })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
  },
}
</script>

<style scoped></style>
